import styles from './faq.module.css'

export function FAQ() {
    return (
        <div style={{ marginTop: '30px' }}>
            <h1 className={styles.h1}>よくある質問 / FAQ</h1>
            <h2 className={styles.h2}>
                <strong>導入にあたって</strong>
            </h2>
            <h3 className={styles.h3}>
                <u>Q：Intelligent Business Analyticsとは何ですか？</u>
            </h3>
            <p className={styles.p}>
                A：Intelligent Business Analyticsは知財起点のアライアンス戦略を支援する製品です。
                <br />
                AIを活用して網羅的かつ高速で情報を収集、分析することにより、バリューチェーン分析による進出市場の特定、保有する知財の技術性・事業性評価、パートナー候補のリストアップなどを迅速に実施し、新規事業の構想を短期間で具体化することができます。
            </p>
            <h3 className={styles.h3}>
                <u>Q：Intelligent Business Analyticsに収録されているデータ・コンテンツの情報ソースはどこですか？</u>
            </h3>
            <p className={styles.p}>A：ビューローヴァンダイク社が提供するOrbis IP及びzephyrになります。</p>
            <h3 className={styles.h3}>
                <u>Q：導入メリットを教えてください</u>
            </h3>
            <p className={styles.p}>
                A：AIを活用して網羅的かつ高速で情報を収集、分析することにより、バリューチェーン分析による進出市場の特定、保有する知財の技術性・事業性評価、パートナー候補のリストアップなどを迅速に実施し、新規事業の構想を短期間で具体化することができます。
            </p>
            <h3 className={styles.h3}>
                <u>
                    Q：契約期間の変更はできますか？
                    <br />
                    また、その際の条件があったら教えてください。
                </u>
            </h3>
            <p className={styles.p}>
                A：契約期間は１年契約でお願いしております。
                <br />
                ご相談は営業担当にお寄せください。
            </p>
            <h3 className={styles.h3}>
                <u>Q：契約期間中のプラン変更はできますか？</u>
            </h3>
            <p className={styles.p}>
                A：プラン変更はアップグレードに限り、受付けいたします。
                <br />
                ご希望、ご相談のあるかたは「jp_techlab_intellectual_property_team@pwc.com」へご連絡ください。
            </p>
            <h2 className={styles.h2}>
                <strong>料金</strong>
            </h2>
            <h3 className={styles.h3}>
                <u>Q：料金について教えてください</u>
            </h3>
            <p className={styles.p}>
                A：以下の３つのプランをご用意しております。
                <br />
                <br />
                Basic(300万円/年：税抜)
                <br />
                <em>
                    バリューチェーン分析を基にした市場親和性計算および企業の強み弱み分析
                    <br />
                </em>
                ベンチマーキングした企業のトラッキング
                <br />
                <br />
                Advanced(540万円/年：税抜)
                <br />
                <em>
                    バリューチェーン分析を基にした市場親和性計算および企業の強み弱み分析
                    <br />
                </em>
                ベンチマーキングした企業のトラッキング
                <br />
                <em>
                    ベンチマーク調査およびミドルリスト生成
                    <br />
                    <br />
                    Managed(750万円/年：税抜)
                    <br />
                </em>
                バリューチェーン分析を基にした市場親和性計算および企業の強み弱み分析
                <br />
                <em>
                    ベンチマーキングした企業のトラッキング
                    <br />
                </em>
                ベンチマーク調査およびミドルリスト生成
                <br />
                <em>
                    研究人材やアントレプレナーといった多様な人材探索
                    <br />
                </em>
                他社におけるR&amp;Dロードマップの推定
            </p>
            <h3 className={styles.h3}>
                <u>Q：お支払方法について</u>
            </h3>
            <p className={styles.p}>
                A：【新規クライアント用】
                <br />
                <em>
                    年間の利用料を一括で銀行振込にてお支払いいただくようお願いしております。
                    <br />
                    ご要望は営業担当へご連絡ください。
                    <br />
                    <br />
                    【契約済みクライアント用】
                    <br />
                </em>
                支払方法や契約期間等の変更をご希望の場合、「jp_techlab_intellectual_property_team@pwc.com」にご連絡ください。
            </p>
            <h3 className={styles.h3}>
                <u>Q：請求書、領収書の発行はおこなっていますか？</u>
            </h3>
            <p className={styles.p}>
                A：請求書について
                <br />
                契約開始月の25日頃に請求ご担当者様宛にメールでお送りします。
                <br />
                <br />
                領収書について
                <br />
                申し訳ございません。発行しておりません。
            </p>
            <h2 className={styles.h2}>
                <strong>製品/サービス</strong>
            </h2>
            <h3 className={styles.h3}>
                <u>Q：推奨環境を教えてください</u>
            </h3>
            <p className={styles.p}>
                A：PCからのご利用（動作確認済み）
                <br />
                <em>
                    Google Chrome ver. 84.0.4147.135 (Official Build) (64-bit)
                    <br />
                </em>
                Edge 89.0.774.54
                <br />
                <br />
                スマートフォン・タブレット端末からのご利用については動作はしますが、保証しておりません。
            </p>
            <h3 className={styles.h3}>
                <u>Q：推奨環境以外のPC環境の場合どうすればよいでしょうか？</u>
            </h3>
            <p className={styles.p}>
                A：推奨環境は以下の通りですが、あくまで「推奨」となります。
                <br />
                PCからのご利用（動作確認済み）
                <br />
                <em>
                    Google Chrome ver. 84.0.4147.135 (Official Build) (64-bit)
                    <br />
                </em>
                Edge 89.0.774.54
                <br />
                スマートフォン・タブレット端末からのご利用については動作はしますが、保証しておりません。
            </p>
            <h3 className={styles.h3}>
                <u>Q：ログインができません</u>
            </h3>
            <p className={styles.p}>
                A：以下のご対応をお願いいたします。
                <br />
                ■パスワードを忘れてしまった場合
                <br />
                以下のステップでご対応をお願いいたします。
                <br />
                ①パスワードを忘れた際には、画面上の「Forgot Password?」をクリックし、パスワード再申請に進んでください。
                <br />
                ②パスワード再申請ページを受領するメールアドレスを入力してください。
                <br />
                ③パスワード再申請ページが記載されたメールが送付されますので、ご自身のメール受信内容を確認してください。
                <br />
                ④初回サインイン時、デバイス登録のため、確認コードが登録時のメールアドレスに送付されます。
                <br />
                ⑤確認コードが登録時のメールアドレスに送付されたことを確認してください。
                <br />
                ⑥Web画面上にコード入力画面が表示されますので、確認コードを入力してください。
                <br />
                ■その他の原因/原因がわからない場合
                <br />
                サポートデスク「jp_intelligent_business_analytics_support_team@pwc.com」へご連絡ください。
            </p>
            <h3 className={styles.h3}>
                <u>Q：パスワードを忘れてしまった場合どうすれば良いですか？</u>
            </h3>
            <p className={styles.p}>
                A：以下のステップでご対応をお願いいたします。
                <br />
                ①パスワードを忘れた際には、画面上の「Forgot Password?」をクリックし、パスワード再申請に進んでください。
                <br />
                ②パスワード再申請ページを受領するメールアドレスを入力してください。
                <br />
                ③パスワード再申請ページが記載されたメールが送付されますので、ご自身のメール受信内容を確認してください。
                <br />
                ④初回サインイン時、デバイス登録のため、確認コードが登録時のメールアドレスに送付されます。
                <br />
                ⑤確認コードが登録時のメールアドレスに送付されたことを確認してください。
                <br />
                ⑥Web画面上にコード入力画面が表示されますので、確認コードを入力してください。
            </p>
            <h3 className={styles.h3}>
                <u>Q：パスワードの変更方法を教えてください</u>
            </h3>
            <p className={styles.p}>
                A：以下のステップでご対応をお願いいたします。
                <br />
                ①パスワードを変更したい際には、画面上の「Forgot
                Password?」をクリックし、パスワード再申請に進んでください。
                <br />
                ②パスワード再申請ページを受領するメールアドレスを入力してください。
                <br />
                ③パスワード再申請ページが記載されたメールが送付されますので、ご自身のメール受信内容を確認してください。
                <br />
                ④初回サインイン時、デバイス登録のため、確認コードが登録時のメールアドレスに送付されます。
                <br />
                ⑤確認コードが登録時のメールアドレスに送付されたことを確認してください。
                <br />
                ⑥Web画面上にコード入力画面が表示されますので、確認コードを入力してください。
            </p>
            <h3 className={styles.h3}>
                <u>Q：アカウントの追加はできますか？</u>
            </h3>
            <p className={styles.p}>
                A：１申込あたり１アカウントのご利用をお願いしております。
                <br />
                複数アカウントが必要な場合は営業担当にご相談ください。
            </p>
            <h2 className={styles.h2}>
                <strong>契約</strong>
            </h2>
            <h3 className={styles.h3}>
                <u>Q：IDの変更はできますか？</u>
            </h3>
            <p className={styles.p}>
                A：IDの変更をご希望の場合は、
                <br />
                「jp_techlab_intellectual_property_team@pwc.com」へご連絡ください。
            </p>
            <h3 className={styles.h3}>
                <u>Q：解約手続きを教えてください</u>
            </h3>
            <p className={styles.p}>
                A：契約更新月の30日前までに書面にてお手続きください。
                <br />
                詳しくは「jp_techlab_intellectual_property_team@pwc.com」へご連絡ください。
            </p>
            <h2 className={styles.h2}>
                <strong>操作方法</strong>
            </h2>
            <h3 className={styles.h3}>
                <u>Q：自社の保有する技術と親和性の高いバリューチェーンを抽出するにはどのようにすればよいでしょうか？</u>
            </h3>
            <p className={styles.p}>
                A：「企業を選択」で自社を選択すると自社のリソースと親和性の高い市場/技術テーマを表示することができます。それを参考にカテゴリやテーマを選択して、バリューチェーンを抽出します。詳細はユーザーガイドP20-P23をご覧ください。
            </p>
            <h3 className={styles.h3}>
                <u>Q：自社の注力するSDGsと親和性の高いバリューチェーンを抽出するにはどのようにすればよいでしょうか？</u>
            </h3>
            <p className={styles.p}>
                A：「企業を選択」で自社を選択すると自社のリソースと親和性の高いSDGsを含む市場/技術テーマを表示することができます。それを参考にカテゴリやテーマを選択して、バリューチェーンを抽出します。詳細はユーザーガイドP20-P23をご覧ください。
            </p>
            <h3 className={styles.h3}>
                <u>
                    Q：バリューチェーンにおける自社の保有する技術の技術性・事業性を評価するにはどのようにすればよいでしょうか？
                </u>
            </h3>
            <p className={styles.p}>
                A：バリューチェーン抽出後、抽出したバリューチェーンのプロセス内外における企業の強みや弱みを評価することができます。詳細はユーザーガイドP25をご覧ください。
            </p>
            <h3 className={styles.h3}>
                <u>Q：参入すべき市場を特定するにはどのようにすればよいでしょうか？</u>
            </h3>
            <p className={styles.p}>
                A：選択したテーマにおける開発トレンドを技術クラスタとして示し、その技術クラスタに対する技術開発・事業開発に関する投資判断に向けてのイノベーションとビジネスの機会に関する評価を把握することができます。詳細はユーザーガイドP26をご参照ください。
            </p>
            <h3 className={styles.h3}>
                <u>Q：市場における企業の強み・弱みを分析するにはどのようにすればよいでしょうか？</u>
            </h3>
            <p className={styles.p}>
                A：技術的なアライアンスとして検討されることの多いスタートアップと、事業的なアライアンスとして検討されることの多い事業会社それぞれに対する評価を行うことができます。
                <br />
                双方でイノベーション評価や市場性を確認できますが、より適切な分析を行うためスタートアップでは成長フェーズの観点を入れています。詳細はユーザーガイドP27-31をご参照ください。
            </p>
            <h3 className={styles.h3}>
                <u>Q：市場における自社が顧客に提供する価値を検討するにはどのようにすればよいでしょうか？</u>
            </h3>
            <p className={styles.p}>
                A：バリューチェーン抽出後、抽出したバリューチェーンのプロセス内外における企業の強みや弱みを評価し、自社のリソースに応じたアライアンス戦略をたてることができます。詳細はユーザーガイドP25-26をご覧ください。
            </p>
            <h3 className={styles.h3}>
                <u>Q：製品やサービスの開発に向けたロードマップを作成するにはどのようにすればよいでしょうか？</u>
            </h3>
            <p className={styles.p}>
                A：製品やサービスの開発に向け、必要な企業の特定については、技術的なアライアンスとして検討されることの多いスタートアップと、事業的なアライアンスとして検討されることの多い事業会社それぞれに対する評価を行うことができます。双方でイノベーション評価や市場性を確認できますが、より適切な分析を行うためスタートアップでは成長フェーズの観点を入れています。詳細はユーザーガイドP27-31をご参照ください。
                <br />
                また、発明者数の大小により該当の技術クラスタ（開発テーマ）における企業の技術開発への注力度を比較することができます。詳細はユーザーガイドP33をご参照ください。
                <br />
                さらに、ユーザはAIで推定された競合などのR&amp;Dロードマップを俯瞰してみることができます。競合などのAIで抽出したトレンドの技術クラスタに対して発明者（研究者）の人口推移を時系列でみることにより、競合がどの技術クラスタに注力しているか、あるいは、投資を抑えているかなどの状況を把握することができます。詳細はユーザーガイドP34をご参照ください。
                <br />
                必要な人材の特定については、技術クラスタの発明者ネットワークにより、自社や他社の発明のハブとなっている人材を特定することができます。詳細はユーザーガイドP32、P33をご参照ください。
                <br />
                また、技術DDや専門家インタビュー、人材採用などより詳細な検討や、実際にコンタクトをとり交渉するサービスを提供しております。
            </p>
            <h3 className={styles.h3}>
                <u>Q：R&amp;Dロードマップを作成するにはどのようにすればよいでしょうか？</u>
            </h3>
            <p className={styles.p}>
                A：製品やサービスの開発に向け、必要な企業の特定については、技術的なアライアンスとして検討されることの多いスタートアップと、事業的なアライアンスとして検討されることの多い事業会社それぞれに対する評価を行うことができます。双方でイノベーション評価や市場性を確認できますが、より適切な分析を行うためスタートアップでは成長フェーズの観点を入れています。詳細はユーザーガイドP25-29をご参照ください。
                <br />
                さらに、企業の発明者数の大小によりその企業の技術開発への注力度を比較することができます。詳細はユーザーガイドP31をご参照ください。
                <br />
                必要な人材の特定については、技術クラスタの発明者ネットワークにより、自社や他社の発明のハブとなっている人材を特定することができます。詳細はP30、P31をご参照ください。
                <br />
                また、技術DDや専門家インタビュー、人材採用などより詳細な検討や、実際にコンタクトをとり交渉するサービスを提供しております。
            </p>
            <h3 className={styles.h3}>
                <u>Q：垂直統合・水平分業に必要となる企業や人材を特定するにはどのようにすればよいでしょうか？</u>
            </h3>
            <p className={styles.p}>
                A：技術的なアライアンスとして検討されることの多いスタートアップと、事業的なアライアンスとして検討されることの多い事業会社それぞれに対する評価を行うことができます。双方でイノベーションの評価や市場性を確認できますが、より適切な分析を行うためスタートアップでは成長フェーズの観点を入れています。詳細はユーザーガイドP27-31をご参照ください。
                <br />
                また、発明者数の大小により該当の技術クラスタ（開発テーマ）における企業の技術開発への注力度を比較することができます。詳細はユーザーガイドP33をご参照ください。
                <br />
                さらに、ユーザはAIで推定された競合などのR&amp;Dロードマップを俯瞰してみることができます。競合などのAIで抽出したトレンドの技術クラスタに対して発明者（研究者）の人口推移を時系列でみることにより、競合がどの技術クラスタに注力しているか、あるいは、投資を抑えているかなどの状況を把握することができます。詳細はユーザーガイドP34をご参照ください。
                <br />
                必要な人材の特定については、技術クラスタの発明者ネットワークにより、自社や他社の発明のハブとなっている人材を特定することができます。詳細はユーザーガイドP32、P33をご参照ください。
                <br />
                また、技術DDや専門家インタビュー、人材採用などより詳細な検討や、実際にコンタクトをとり交渉するサービスを提供しております。
            </p>
            <h3 className={styles.h3}>
                <u>Q：市場における競合の強み・弱みを分析するにはどのようにすればよいでしょうか？</u>
            </h3>
            <p className={styles.p}>
                A：技術的なアライアンスとして検討されることの多いスタートアップと、事業的なアライアンスとして検討されることの多い事業会社それぞれに対する評価を行うことができます。
                <br />
                双方でイノベーション評価や市場性を確認できますが、より適切な分析を行うためスタートアップでは成長フェーズの観点を入れています。詳細はユーザーガイドP27-31をご参照ください。
            </p>
            <h3 className={styles.h3}>
                <u>
                    Q：競合の注力している技術分野・開発分野・開発規模を推定したいと思っています。どのようにすればよいでしょうか？
                </u>
            </h3>
            <p className={styles.p}>
                A：「企業を選択」で競合他社を選択することで、自社を選択したときと同じように競合他社の分析を行うことができます。詳細についてはそれぞれのFAQをご参照ください。
            </p>
            <h2 className={styles.h2}>
                <strong>データ・コンテンツ</strong>
            </h2>
            <h3 className={styles.h3}>
                <u>Q：特許情報の範囲は世界のものですか？日本のものですか？</u>
            </h3>
            <p className={styles.p}>A：特許情報は世界のものを使用しております。</p>
            <h3 className={styles.h3}>
                <u>Q：「SELECT A COMPANY」で、同一の企業名が複数表示されます。</u>
            </h3>
            <p className={styles.p}>
                A：企業名は同一だが登録国が異なるなどの理由で別エンティティとして登録されております。こちらについては現在システムでの表示方法を検討中です。
            </p>
            <h3 className={styles.h3}>
                <u>Q：「SELECT A COMPANY」で、探したい企業が出てきません。</u>
            </h3>
            <p className={styles.p}>
                A：例えば「ABC Corporation」を探したいときには、「ABC」だけでなく、「ABC
                Corp」など、スペースやその他文字列を追加することで候補に表示されることがあります。
            </p>
            <h3 className={styles.h3}>
                <u>Q：特許出願件数・特許登録件数・有効特許件数の違いを教えてください</u>
            </h3>
            <p className={styles.p}>
                A：特許出願件数とは出願された全ての件数であり、そこから各国特許庁に登録された特許を登録件数として数えています。さらに、失効・放棄されていない現在有効な特許の件数を有効特許件数としています。
            </p>
            <h3 className={styles.h3}>
                <u>Q：「選択したテーマとの親和性が高い企業」はどのように計算しているのですか？</u>
            </h3>
            <p className={styles.p}>
                A：選択した市場/技術テーマにどの企業がどの程度寄与しているかを保有特許の重要度から算出しています。
                <br />
                具体的には、選択した企業の知的財産（特許）が入力テーマにどの程度寄与しているかを保有特許の重要度から算出しています。
            </p>
            <h3 className={styles.h3}>
                <u>Q：「選択した企業との親和性が高いテーマ」はどのように計算しているのですか？</u>
            </h3>
            <p className={styles.p}>
                A：選択した企業が市場/技術テーマにどの程度寄与しているかを保有特許の重要度から算出しています。
                <br />
                具体的には、選択した企業の知的財産（特許）が入力テーマにどの程度寄与しているかを保有特許の重要度から算出しています。
            </p>
            <h3 className={styles.h3}>
                <u>Q：それぞれの技術テーマの範囲はどのように定義しているのですか？</u>
            </h3>
            <p className={styles.p}>
                A：特許庁の特許出願技術動向報告書や機動的ミクロ調査報告書などを参考に、PwCのアナリストが定義しています。
            </p>
            <h3 className={styles.h3}>
                <u>Q：スコアとはどのような数値ですか？</u>
            </h3>
            <p className={styles.p}>
                A：スコアとは、技術の類似性の観点からクラスタリングを実施して、因子分析の結果、各クラスタで各企業がどの程度寄与しているのかを表す指標です。
                <br />
                スコアが大きければ、企業が技術クラスタに貢献している程度が大きいと考えられます。
            </p>
            <h3 className={styles.h3}>
                <u>Q：インパクトとはどのような数値ですか？</u>
            </h3>
            <p className={styles.p}>
                A：インパクトとは、被引用数、ファミリー等の特許情報により算出している指標で、インパクトが大きいことは当該特許が幅広い影響力を行使できる強い特許であることを表します。
            </p>
            <h3 className={styles.h3}>
                <u>Q：スコアとインパクトはどのように使い分けるのか？</u>
            </h3>
            <p className={styles.p}>
                A：自社(or選択企業)のスコアを確認することで選択したテーマでの技術におけるポジションを俯瞰できます。企業の強み・弱みを知りどこを強化すべきかの指標になります。
                <br />
                一方でインパクトを確認することで、特許の強さを把握することができます。引用数や関連特許が多ければ、インパクトは大きくなります。自社のインパクトが大きい場合、選択したテーマにおいて保有特許のカバー範囲が大きくなるため、知財戦略としては、現状維持か強化するか否かの指標になります。他社のインパクトが大きい場合は、技術開発する際に特許侵害等に注意を払う必要が必要があるため、自社開発や権利強化に力を入れるか等を検討する材料になります。
            </p>
            <h3 className={styles.h3}>
                <u>Q：市場性はどのように計算しているのでしょうか？</u>
            </h3>
            <p className={styles.p}>A：マイノリティ出資額又は事業規模の大きさにより評価しています。</p>
            <h3 className={styles.h3}>
                <u>Q：競争指数の定義を教えてください</u>
            </h3>
            <p className={styles.p}>
                A：競争指数とは、選択した企業と同じプロセスに該当する企業の合計スコアと選択した企業のスコアの比率です。競争指数が大きいことは該当する企業が自社の含まれているプロセスで高い技術力をもつことを表します。
            </p>
            <h3 className={styles.h3}>
                <u>Q：共創指数の定義を教えてください</u>
            </h3>
            <p className={styles.p}>
                A：共創指数とは、選択した企業と異なるプロセスに該当する企業の合計スコアと選択した企業のスコアの比率です。共創指数が大きいことは該当する企業が自社の含まれているプロセス以外でも幅広い技術をもつことを表します。
            </p>
            <h3 className={styles.h3}>
                <u>Q：因子負荷量とはどのような数値ですか？</u>
            </h3>
            <p className={styles.p}>
                A：Intelligent Business
                Analyticsでは、各技術区分のクラスタへの寄与度を因子分析により示しており（因子負荷量）、数字が大きいほど寄与度が大きいことを表します。
            </p>
            <h3 className={styles.h3}>
                <u>Q：事業規模はどのように計算しているのでしょうか？</u>
            </h3>
            <p className={styles.p}>A：会社全体の直近期の連結売上高です。</p>
            <h3 className={styles.h3}>
                <u>Q：ビジネスインパクトとはどのような数値ですか？</u>
            </h3>
            <p className={styles.p}>
                A：企業の売上高とマイノリティ出資によって出資を受けた金額を合計したもので、その企業の市場における存在感の大きさを示すと考えます。
            </p>
            <h3 className={styles.h3}>
                <u>Q：イノベーション評価スコアとはどのような数値ですか？</u>
            </h3>
            <p className={styles.p}>
                A：成長ステージにスコアの情報を加味した値となります。
                <br />
                スコアとは、技術の類似性の観点からクラスタリングを実施して、因子分析の結果、各クラスタで各企業がどの程度寄与しているのかを表す指標です。
                <br />
                スコアが大きければ、企業が技術クラスタに貢献している程度が大きいと考えられます。
            </p>
            <h3 className={styles.h3}>
                <u>Q：開発中心性とはどのような数値ですか？</u>
            </h3>
            <p className={styles.p}>
                A：ネットワーク分析においてネットワーク内でどれだけ中心にあるかを表す値となります。
                <br />
                Intelligent Business
                Analyticsでは、より多くの発明者と多くの特許を出願しているほど値が大きくなり、ハブ人材を特定する際に利用します。
            </p>
            <h2 className={styles.h2}>
                <strong>サポート窓口</strong>
            </h2>
            <h3 className={styles.h3}>
                <u>Q：その他のお問い合わせ</u>
            </h3>
            <p className={styles.p}>
                A：FAQ,ユーザーガイドを準備しております。
                <br />
                解決できない場合はサポートデスクへご連絡ください。
                <br />
                連絡先：「jp_intelligent_business_analytics_support_team@pwc.com」
            </p>
        </div>
    )
}
